import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translation } from '../../../../utils/helpers'
import { setPageTitle } from '../../../../actions/common'
import { isEqual } from 'lodash'

import Icon from '../../../elements/icon'
// import { Icons } from '../../../elements/icons'

import './topbar.scss'

class TopBar extends Component {

  constructor (props) {
    super(props)
    this.prevRoutePath = props.router.routes[props.router.routes.length - 1].path
    this.prevCurrentUserToken = ''
  }

  componentWillReceiveProps (nextProps) {
    const defaultPageTitle = { title: 'Apromas', icon: null }
    let topRoute = nextProps.router.routes[nextProps.router.routes.length - 1]

    // Set page title from route only if route was changed (ignore certain route parameter changes).
    const filterRouteParameters = (route) => {
      if (typeof route === 'string') {
        route = route.replace('/:type', '')
        route = route.replace('/:value', '')
        route = route.replace('/:separateType', '')
      }
      return route
    }

    const checkCurrentUserChanged = () => {
      if (this.props.auth !== undefined && this.props.auth.Token !== this.prevCurrentUserToken) {
        this.prevCurrentUserToken = this.props.auth.Token
        return true
      }
      return false
    }

    if (filterRouteParameters(topRoute.path) !== filterRouteParameters(this.prevRoutePath) || this.props.pageTitle.title === defaultPageTitle.title || checkCurrentUserChanged()) {
      // let before = filterRouteParameters(this.prevRoutePath)
      this.prevRoutePath = filterRouteParameters(topRoute.path)
      let topBarData = null
      if (topRoute.topBar) {
        topBarData = {...topRoute.topBar}
      }
      if (topBarData === null) {
        if (!isEqual(defaultPageTitle, this.props.pageTitle)) {
          // this.props.setPageTitle(defaultPageTitle)
        }
      } else {
        if (!isEqual(topBarData, this.props.pageTitle)) {
          this.props.setPageTitle(topBarData)
        }
      }
    }
  }

  render () {
    let icon = null
    let title = 'Apromas'
    if (this.props.pageTitle !== null) {
      if (this.props.pageTitle.icon !== undefined) icon = this.props.pageTitle.icon
      if (this.props.pageTitle.title !== undefined) {
        title = this.props.pageTitle.title

        if (typeof title === 'number') title = translation(title)
      }
      if (typeof this.props.pageTitle.extra === 'string' && this.props.pageTitle.extra.trim().length > 0) {
        title += ' - ' + this.props.pageTitle.extra
      }
    }
    return (
      <div className='layout__header'>
        <Icon size='m' icon={icon} />
        <div className='title'>{title}</div>
        {this.props.children}
      </div>
    )
  }

}

TopBar.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    pageTitle: state.common.pageTitle
  }
}

export default connect(mapStateToProps, {
  setPageTitle
})(TopBar)



// WEBPACK FOOTER //
// ./src/app/shared/components/Layout/TopBar/index.js